






import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class SmallText extends Vue {
  @Prop({ type: String, default: "normal" }) weight!: string;
  @Prop({ type: Number, default: 12 }) size!: number;
  @Prop({ type: String, default: "" }) color!: string;

  get textStyle() {
    return {
      color: this.color,
      fontSize: `${this.size / 16}rem`,
      fontWeight: this.weight
    };
  }
}
